const LOGO_URL = "/logo.png";

export const Logo = ({ className = "h-[30px] sm:h-[41px] w-auto" }) => (
  <img loading="lazy" decoding="async" src={LOGO_URL} alt="Verde Capital" className={className} data-testid="logo" />
);

export default Logo;
